import useAppUser from 'hooks/useAppUser';
import useIsPageWithoutFooter from 'hooks/layout/useIsPageWithoutFooter';
import AgencyFooter from './AgencyFooter';
import OwnerFooter from './OwnerFooter';

const Footer = () => {
  const { isEmployee, isOwner } = useAppUser();
  const isPageWithoutFooter = useIsPageWithoutFooter();

  if (isPageWithoutFooter) {
    return null;
  }

  if (isEmployee) {
    return <AgencyFooter />;
  }

  if (isOwner) {
    return <OwnerFooter />;
  }

  return null;
};

export default Footer;
